import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "leave_form"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = {
    key: 0,
    class: "lead"
};
const _hoisted_6 = {
    key: 1,
    class: "lead"
};
const _hoisted_7 = { key: 1 };
const _hoisted_8 = {
    key: 2,
    class: "lead"
};
const _hoisted_9 = { class: "sel_wrapper" };
const _hoisted_10 = ["value"];
const _hoisted_11 = {
    key: 0,
    class: "err"
};
const _hoisted_12 = {
    key: 0,
    class: "sub_t"
};
const _hoisted_13 = {
    key: 1,
    class: "err"
};
const _hoisted_14 = { class: "f_pass w60" };
const _hoisted_15 = {
    key: 0,
    class: "err"
};
const _hoisted_16 = { class: "bt_box" };
const _hoisted_17 = {
    id: "confirm-modal",
    class: "modal min js-modal"
};
const _hoisted_18 = { class: "modal-content" };
const _hoisted_19 = { class: "close_bt bt_modal_close" };
import { ref, watch, onBeforeMount, onMounted, onUnmounted, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import { PlanCategory, LeaveReason, UserType, AuthRole } from '@util/Consts';
import { isObjEmpty } from '@util/Common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'leave_form',
    props: {
        common: {},
        errors: {}
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            leave_reason: null,
            other_leave_reason: '',
            leave_remark: '',
            password: '',
        });
        const options = ref([]);
        const confirmModal = ref();
        // 文字数チェック
        watch(() => form.other_leave_reason, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.other_leave_reason = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.leave_remark, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.leave_remark = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.password, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.password = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onClickOk = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('account.leave.update'));
        };
        const onClickConfirm = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('account.leave.confirm'), () => {
                if (isObjEmpty(props.errors)) {
                    confirmModal.value.click();
                }
            });
        };
        onBeforeMount(() => {
            axios.get('/leave-reasons').then(response => {
                var _a;
                options.value = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : null;
            }).catch(error => {
                console.error('Failed to load leave-reasons:', error);
                options.value = [];
            });
        });
        onMounted(() => {
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _cache[65] || (_cache[65] = _createElementVNode("iframe", {
                    style: { "display": "none" },
                    onload: "resizeTextarea(1,4), resizeTextarea(2,7)"
                }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[61] || (_cache[61] = _createElementVNode("h2", null, "退会申請", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[58] || (_cache[58] = _createElementVNode("p", { class: "title" }, "退会前の注意事項", -1)),
                                (props.common['auth.user'].type === _unref(UserType).MENTOR && props.common['auth.user'].plan_id == _unref(PlanCategory).FREE_PLAN)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _cache[4] || (_cache[4] = [
                                        _createTextVNode(" 下記の退会ボタンを押した時点で、即時退会となります。"),
                                        _createElementVNode("br", null, null, -1),
                                        _createTextVNode(" また、未受取りの報酬はお受取りできません。"),
                                        _createElementVNode("br", null, null, -1),
                                        _createTextVNode(" 退会するとアカウントは無効となり、ログインできない状態となるので"),
                                        _createElementVNode("br", null, null, -1),
                                        _createTextVNode(" 回答中のまま、退会とならないようにご注意ください。"),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("br", null, null, -1),
                                        _createTextVNode(" 退会後も、表示名、投稿内容、評価、業種、職種は公開されたままとなります。"),
                                        _createElementVNode("br", null, null, -1),
                                        _createTextVNode(" それ以外の、自己紹介、スキル要約などのプロフィール情報は非公開となります。"),
                                        _createElementVNode("br", null, null, -1)
                                    ])))
                                    : _createCommentVNode("", true),
                                (props.common['auth.user'].type === _unref(UserType).MENTOR && props.common['auth.user'].plan_id !== _unref(PlanCategory).FREE_PLAN)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                        _cache[6] || (_cache[6] = _createTextVNode(" 下記の退会ボタンを押した時点で、即時退会となります。")),
                                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                        _cache[8] || (_cache[8] = _createTextVNode(" 退会された月の１カ月分の基本料金は請求されます（日割り計算はしません）。")),
                                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                        _cache[10] || (_cache[10] = _createTextVNode(" 退会時に当月の質問チケットが残っていても、無効となり払い戻しはありません。")),
                                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                        _cache[12] || (_cache[12] = _createTextVNode(" また、未受取りの報酬はお受取りできません。")),
                                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                        _cache[15] || (_cache[15] = _createTextVNode(" 退会するとアカウントは無効となり、ログインできない状態となるので ")),
                                        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                        _cache[17] || (_cache[17] = _createTextVNode(" 質問中や回答中のまま、退会とならないようにご注意ください。")),
                                        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                                        _cache[20] || (_cache[20] = _createTextVNode(" アカウントを残す場合には、 ")),
                                        (props.common.role === _unref(AuthRole).QUESTIONER)
                                            ? (_openBlock(), _createBlock(_unref(Link), {
                                                key: 0,
                                                href: "/plan"
                                            }, {
                                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                    _createTextVNode(" 料金プランを変更 ")
                                                ])),
                                                _: 1,
                                                __: [5]
                                            }))
                                            : _createCommentVNode("", true),
                                        (props.common.role === _unref(AuthRole).MENTOR)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 料金プランを変更 "))
                                            : _createCommentVNode("", true),
                                        _cache[21] || (_cache[21] = _createTextVNode(" して ")),
                                        _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                                        _cache[23] || (_cache[23] = _createTextVNode(" 有料プランからフリープランへの変更することもご検討ください。")),
                                        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                                        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                                        _cache[26] || (_cache[26] = _createTextVNode(" 退会後も、表示名、投稿内容、評価、業種、職種は公開されたままとなります。")),
                                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                                        _cache[28] || (_cache[28] = _createTextVNode(" それ以外の、自己紹介、スキル要約などのプロフィール情報は非公開となります。 "))
                                    ]))
                                    : _createCommentVNode("", true),
                                (props.common['auth.user'].type === _unref(UserType).QUESTIONER)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                        _cache[30] || (_cache[30] = _createTextVNode(" 下記の退会ボタンを押した時点で、即時退会となります。")),
                                        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                                        _cache[32] || (_cache[32] = _createTextVNode(" 退会された月の１カ月分の基本料金は請求されます（日割り計算はしません）。")),
                                        _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                                        _cache[34] || (_cache[34] = _createTextVNode(" 退会時に当月の質問チケットが残っていても、無効となり払い戻しはありません。")),
                                        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                                        _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                                        _cache[37] || (_cache[37] = _createTextVNode(" 退会するとアカウントは無効となり、ログインできない状態となるので ")),
                                        _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                        _cache[39] || (_cache[39] = _createTextVNode(" 相談中のまま、退会とならないようにご注意ください。")),
                                        _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
                                        _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
                                        _cache[42] || (_cache[42] = _createTextVNode(" アカウントを残す場合には、")),
                                        _createVNode(_unref(Link), { href: "/plan" }, {
                                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                _createTextVNode("料金プランを変更")
                                            ])),
                                            _: 1,
                                            __: [29]
                                        }),
                                        _cache[43] || (_cache[43] = _createTextVNode("して ")),
                                        _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                                        _cache[45] || (_cache[45] = _createTextVNode(" 有料プランからフリープランへの変更することもご検討ください。")),
                                        _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                                        _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                                        _cache[48] || (_cache[48] = _createTextVNode(" 退会後も、表示名、投稿内容、業種、職種は公開されたままとなります。")),
                                        _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                                        _cache[50] || (_cache[50] = _createTextVNode(" それ以外の、会社概要、年商、社員数などのプロフィール情報は非公開となります。")),
                                        _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1))
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[59] || (_cache[59] = _createElementVNode("p", { class: "title" }, "退会される場合", -1)),
                                _cache[60] || (_cache[60] = _createElementVNode("p", { class: "lead" }, [
                                    _createTextVNode(" 当サービスをご利用頂きありがとうございました。"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" 今後のサービス向上のため、ぜひ退会の理由やお気づきになった点をお聞かせください。 ")
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onClickConfirm, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[54] || (_cache[54] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode("退会理由"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).leave_reason) = $event)),
                                                    id: "sel_1",
                                                    class: "w80"
                                                }, [
                                                    _cache[52] || (_cache[52] = _createElementVNode("option", { value: "" }, "　", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: option.id
                                                        }, _toDisplayString(option.name), 9, _hoisted_10));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(form).leave_reason]
                                                ]),
                                                ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.leave_reason)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(props.errors.leave_reason), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            (_unref(form).leave_reason === _unref(LeaveReason).OTHER_REASON)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "その他の理由"))
                                                : _createCommentVNode("", true),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).other_leave_reason) = $event)),
                                                name: "",
                                                placeholder: "退会理由を記入",
                                                id: "textarea_1",
                                                oninput: "resizeTextarea(1,4)"
                                            }, null, 512), [
                                                [_vShow, _unref(form).leave_reason === _unref(LeaveReason).OTHER_REASON],
                                                [_vModelText, _unref(form).other_leave_reason]
                                            ]),
                                            (!((_b = props.errors) === null || _b === void 0 ? void 0 : _b.leave_reason) && (_unref(form).leave_reason === _unref(LeaveReason).OTHER_REASON || ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.other_leave_reason)))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(props.errors.other_leave_reason), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[55] || (_cache[55] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" ご意見、ご要望、"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createTextVNode("ご感想など"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "optionally" }, "任意")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).leave_remark) = $event)),
                                                name: "",
                                                placeholder: "サービスが使いにくかった点や改善点など、何かお気づきの点がございましたら是非ご記入ください。",
                                                id: "textarea_2",
                                                oninput: "resizeTextarea(2,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).leave_remark]
                                            ])
                                        ]),
                                        _cache[56] || (_cache[56] = _createElementVNode("dt", { class: "must" }, " パスワード ", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).password) = $event)),
                                                    class: "wmax",
                                                    type: "password",
                                                    id: "textPassword_1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).password]
                                                ]),
                                                _cache[53] || (_cache[53] = _createElementVNode("span", {
                                                    id: "buttonEye_1",
                                                    class: "fa fa-eye",
                                                    onclick: "pushHideButton(1)"
                                                }, null, -1))
                                            ]),
                                            (props.errors.password)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.errors.password), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[57] || (_cache[57] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "bt_1"
                                        }, "退会してログアウトする", -1)),
                                        _createElementVNode("a", {
                                            class: "bt_1 modal_win",
                                            ref_key: "confirmModal",
                                            ref: confirmModal,
                                            "data-target": "confirm-modal",
                                            style: { "display": "none" }
                                        }, null, 512)
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createElementVNode("div", _hoisted_17, [
                            _cache[64] || (_cache[64] = _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1)),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                ]),
                                _createElementVNode("div", { class: "pop" }, [
                                    _cache[63] || (_cache[63] = _createElementVNode("h2", null, "本当に退会してよろしいですか？", -1)),
                                    _createElementVNode("div", { class: "bt_box clear" }, [
                                        _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                            _cache[62] || (_cache[62] = _createElementVNode("li", null, [
                                                _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
                                            ], -1)),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("p", {
                                                    class: "bt_modal_close bt_ok",
                                                    onClick: onClickOk
                                                }, "OK")
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
